import React, {Component} from 'react';
import {Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {request} from "../../../helper/APIUtils";
import {hasUserRight, showAxiosError} from "../../../helper/helper";
import Table from "../../../components/Table/Table";
import moment from "moment";
import MiniButton from "../../../components/MiniButton";
import CreditChangeModal from "./CreditChangeModal";
import Alert from "react-s-alert";
import SquareButtonX from "../../../components/SquareButtonX";
import CreditModal from "./CreditModal";
import {EntegratorIdentifiers, UserRightsEnum} from "../../../helper/enums";
import {EntegratorConf, VirtualHost} from "../../../constants";
import '../Customer.css';
import ReactLoading from "react-loading";
import {defterUnitName, defterUnitNameShort, showCreditEdit} from "../../../helper/permission";
import TextOverFlowTooltip from "../../../components/TextOverFlowTooltip";

class CreditHistoryModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            content: [],
            loading: false,
            loading2:false,
            total: 0,
            page: 0,
            size: 5,
            manual: false,
            selected: [],
            alert: null,
            creditModal: false,
            priceAmountMap: {},
            priceAmountMbMap: {},
            tolerateDay: 0,
            isMobile : window.innerWidth > 991 ? false : true,
            customerList: [],
            allowWholeCreditLoad: false
        };

        this.closeLoadCreditChangeModal = this.closeLoadCreditChangeModal.bind(this);
        this.modifyDate = this.modifyDate.bind(this);
        this.defineCreditAction = this.defineCreditAction.bind(this);
        this.fetch = this.fetch.bind(this);
        this.fetchCreditHistoryAll = this.fetchCreditHistoryAll.bind(this);
        this.getStatusOfAllowSubDistLoad = this.getStatusOfAllowSubDistLoad.bind(this);
        this.totalCredi = this.totalCredi.bind(this);
        this.editClicked = this.editClicked.bind(this);
        this.deleteCreditPurchase = this.deleteCreditPurchase.bind(this);
        this.openLoadCreditModal=this.openLoadCreditModal.bind(this);
        this.closeLoadCreditChangeModal=this.closeLoadCreditChangeModal.bind(this);
        this.closeLoadCreditModal=this.closeLoadCreditModal.bind(this);
        this.openLoadCreditModal=this.openLoadCreditModal.bind(this);
        this.getTolerateDay = this.getTolerateDay.bind(this);
        this.getTrClass = this.getTrClass.bind(this);
    }

    componentDidMount() {
        let self = this;
        self.fetchCreditHistoryAll();
        self.getStatusOfAllowSubDistLoad();

        if(self.props.customer)
        {
            let customer=self.props.customer;
            self.setState({customer});
        }
        if(self.props.priceAmountMap)
        {
            let priceAmountMap=self.props.priceAmountMap;
            self.setState({priceAmountMap});
        }
        if(self.props.priceAmountMbMap)
        {
            let priceAmountMbMap=self.props.priceAmountMbMap;
            self.setState({priceAmountMbMap});
        }

        self.getTolerateDay();
    }

    fetch(accessor, direction,page, size) {
        let self = this;
        let data = self.props.customer ? self.props.customer.recordId : '';
        let url = '/customer/' + (self.props.customer ? 'fetchCreditHistory' : 'fetchCreditHistoryByUser') + '?page=' + page + '&size=' + size;
        let params = {
            url: url,
            method: "post",
            data: data
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual});
        request(params)
        .then(function (response) {
            self.setState({
                content: response.data.content,
                manual: false,
                loading: false,
                page: page,
                size: size,
                total: response.data.totalElements
            });
        }).catch(function (error) {
            showAxiosError(error);
            self.setState({manual: false, loading: false})
        });
    }

    fetchCreditHistoryAll() {
        let self = this;
        let data = self.props.customer ? self.props.customer.recordId : '';
        let url = '/customer/' + (self.props.customer ? 'fetchCreditHistoryAll' : 'fetchCreditHistoryAllByUser');
        let params = {
            url: url,
            method: "post",
            data: data
        };
        self.setState({loading2: true});
        request(params)
        .then(function (response) {
            self.totalCredi(response);
        }).catch(function (error) {
            showAxiosError(error);
            self.setState({loading2: false})
        });
    }

    getStatusOfAllowSubDistLoad(){
        let self = this;
        if(self.props.customer && self.props.customer.recordId) {
            let params = {
                url: "/customer/getStatusForWholeCreditLoad/" + self.props.customer.recordId,
                method: "get"
            };
            request(params)
                .then(function (response) {
                    self.setState({
                        allowWholeCreditLoad: response.data && response.data.allowSubDistWholeCreditLoad ? response.data.allowSubDistWholeCreditLoad : false
                    });
                }).catch(function (error) {
                showAxiosError(error);
                self.setState({manual: false})
            });
        }
    }

    getTolerateDay() {
        let self = this;
        let params = {
            url: "/credit/getTolerateDay",
            method: "get"
        };
        request(params)
        .then(function (response) {
            self.setState({
                tolerateDay: response.data && response.data.tolerateDay ? response.data.tolerateDay : 15
            });
        }).catch(function (error) {
            showAxiosError(error);
            self.setState({manual: false})
        });
    }

    totalCredi(response) {
        let creditHistoryAll = (response.data.creditPurchaseList && response.data.creditPurchaseList[0].length>0)?response.data.creditPurchaseList[0]: [];
        let creditConsumeAll = (response.data.creditConsumeList && response.data.creditConsumeList[0].length>0)?response.data.creditConsumeList[0]: [];
        let customerList = (response.data.customerList && response.data.customerList[0].length>0)? response.data.customerList[0]: [];

        let numberOfCredits = 0;
        let numberOfActiveCredits = 0;
        let areaSize =0;
        let activeAreaSize =0;
        let numberOfSafe = 0;
        let activeNumberOfSafe = 0;
        let numberOfCreditsConsumed = 0;
        let areaSizeConsumed = 0;
        let numberOfSafeConsumed = 0;
        creditHistoryAll && creditHistoryAll.map((row, index) => {
            if(row){
                if (row.unit === 1) {
                    if (row.creditAction === 4){
                        numberOfActiveCredits = numberOfActiveCredits - row.consideredCount;
                        numberOfCredits = numberOfCredits - row.count;
                    }else{
                        numberOfActiveCredits = numberOfActiveCredits + row.consideredCount;
                        numberOfCredits = numberOfCredits + row.count;
                    }
                } else if (row.unit === 2) {
                    if (row.creditAction === 4){
                        activeAreaSize = activeAreaSize - row.consideredCount;
                        areaSize = areaSize - row.count;
                    }else{
                        activeAreaSize = activeAreaSize + row.consideredCount;
                        areaSize = areaSize + row.count;
                    }
                } else if (row.unit === 3) {
                    if (row.creditAction === 4){
                        activeNumberOfSafe = activeNumberOfSafe - row.consideredCount;
                        numberOfSafe = numberOfSafe - row.count;
                    }else{
                        activeNumberOfSafe = activeNumberOfSafe + row.consideredCount;
                        numberOfSafe = numberOfSafe + row.count;
                    }
                }
            }
        });
        creditConsumeAll && creditConsumeAll.map((row, index) => {
            if(row) {
                if (row.unit === 1) {
                    numberOfCreditsConsumed = row.amount;
                } else if (row.unit === 2) {
                    areaSizeConsumed = row.amount;
                } else if (row.unit === 3) {
                    numberOfSafeConsumed = row.amount;
                }
            }
        });

        this.setState({
            numberOfCredits,
            numberOfActiveCredits,
            areaSize,
            activeAreaSize,
            numberOfSafe,
            activeNumberOfSafe,
            numberOfCreditsConsumed,
            areaSizeConsumed,
            numberOfSafeConsumed,
            loading2:false,
            customerList
        });
    }

    editClicked(row) {
        this.setState({creditChangeModal: true, selected: row});
    }

    deleteCreditPurchase(row) {
        let self = this;
        self.setState({alert: null});
        let params = {
            url: "/customer/deleteCreditPurchase",
            method: "post",
            data: row.recordId
        };
        request(params)
        .then(function (response) {
            Alert.success("İşlem başarıyla silindi.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
            self.setState({manual:true},()=>self.fetchCreditHistoryAll());
        }).catch(function (error) {
            showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
        });
    }

    defineCreditUnit(data) {
        switch (data.unit) {
            case 1:
                return ['Adet', 'Kontör Adedi'];
            case 2:
                return [defterUnitNameShort(EntegratorConf.identifier), defterUnitName(EntegratorConf.identifier)];
            case  3:
                return ['E-Arşiv Kasa', 'E-Arşiv Kasa Adedi'];
        }
    }

    defineCreditAction(data) {
        switch (data.creditAction) {
            case 0:
                return 'Sıfır Başlangıç';
            case 1:
                return 'Satın Alma';
            case  2:
                return 'Devir (Giriş)';
            case  3:
                return 'Hediye';
            case  4:
                return 'Devir (Çıkış)';
            case  5:
                return 'Transfer';
            case  6:
                return 'Kredi Havuzuna Katılma';
            case  7:
                return 'Kredi Havuzundan Ayrılma';
        }
    }

    modifyDate(date) {
        return moment(date).format('DD-MM-YYYY');
    }

    closeLoadCreditChangeModal() {
        let self=this;
        self.setState({
            creditChangeModal: false,
            manual:true
        },()=>self.fetchCreditHistoryAll());
    }

    openLoadCreditModal(customer) {
        this.setState({creditModal: true});
    }

    closeLoadCreditModal() {
        let self =this;
        self.setState({creditModal: false, manual:true},()=>self.fetchCreditHistoryAll());
    }

    getTrClass(row) {
        let dToMsCoef = (60*60*24*1000);
        let tolerateDay = this.state.tolerateDay;
        let toleranceMs = tolerateDay * dToMsCoef;

        let expirationDate = moment(row.expireDate).valueOf();
        let now = moment().valueOf();

        let msToExpiration = expirationDate - now;

        if (msToExpiration < 0) {
            return 'expired-credit-row';
        } else if (msToExpiration > 0 && msToExpiration < toleranceMs) {
            return "expiring-credit-row";
        } else {
            return ""
        }
    }

    render() {
        const {content, isMobile} = this.state;

        let columns = [
            {
                Header: "Vkn/Tckn",
                title: "Vkn/Tckn",
                accessor: "vknTckn",
                sortable: false
            },
            {
                Header: "Alınan",
                title:'Alınan',
                accessor: "count",
                sortable: false,
                Cell: row => (
                    <label>{row.count} {this.defineCreditUnit(row)[0]}</label>
                )
            },
            {
                Header: "Kullanılan",
                title: "Kullanılan",
                accessor: "consideredCount",
                sortable: false,
                Cell: row => (
                    <label>{this.getTrClass(row) === 'expired-credit-row' ? (row.consideredCount +" "+ this.defineCreditUnit(row)[0]):""} </label>
                )
            },
            {
                Header: "Yanan",
                title: "Yanan",
                accessor: "consideredCount",
                sortable: false,
                Cell: row => (
                    <label>{this.getTrClass(row) === 'expired-credit-row' ? (row.count - row.consideredCount +" "+ this.defineCreditUnit(row)[0]):""} </label>
                )
            },
            {
                Header: "Birim",
                title: "Birim",
                accessor: "unit",
                sortable: false,
                Cell: row => (
                    <label>{this.defineCreditUnit(row)[1]}</label>
                )
            },
            {
                Header: "İşlem",
                title: "İşlem",
                accessor: "creditAction",
                sortable: false,
                Cell: row => (
                    <label>{this.defineCreditAction(row)}</label>
                )
            },
            {
                Header: "Başlangıç",
                title: "Başlangıç",
                accessor: "",
                sortable: false,
                Cell: row => (
                    <label>{this.modifyDate(row.startDate)}</label>
                )
            },
            {
                Header: "Bitiş",
                title: "Bitiş",
                accessor: "",
                sortable: false,
                Cell: row => (
                    <label>{this.modifyDate(row.expireDate)}</label>
                )
            }
        ];

        let columns2 = [
            {
                Header: "Vkn/Tckn",
                title: "Vkn/Tckn",
                accessor: "vknTckn",
                sortable: false
            },
            {
                Header: "Unvan",
                title:'Unvan',
                accessor: "formattedName",
                sortable: false,
                Cell: row => (
                    <label>{row.formattedName}</label>
                )
            }];

        if(!this.props.from) {
            columns.push({
                Header: "İşlem Tarihi",
                title: "İşlem Tarihi",
                accessor: "",
                sortable: false,
                Cell: row => (
                    <label>{this.modifyDate(row.purchaseDate)}</label>
                )
            });
            if([EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART,EntegratorIdentifiers.MBT, EntegratorIdentifiers.DEVATEK,
                EntegratorIdentifiers.BYM, EntegratorIdentifiers.AKTIF].includes(EntegratorConf.identifier)){
                columns.push({
                    Header: "Kontör Yükleyen",
                    title: "Kontör Yükleyen",
                    accessor: "addedUser",
                    sortable: false,
                });
            }
            if ((this.props.isEntegrator || this.props.isDistributor) && [EntegratorIdentifiers.MBT, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(EntegratorConf.identifier)){
                columns.push({
                    Header: "Açıklama",
                    title: "Açıklma",
                    accessor: "explanation",
                    sortable: false,
                    Cell: row => (<div><TextOverFlowTooltip text={row.explanation} maxLength={10}/></div>)
                });
            }
            columns.push({
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                width: "10%",
                Cell: row => (
                    <div>
                        {((this.props.isEntegrator || (showCreditEdit(EntegratorConf.identifier) && (this.props.isDistributor && this.props.currentUser.allowCreditChange))) && this.getTrClass(row) !== 'expired-credit-row') &&
                        <MiniButton title="Düzenle" faIcon="fa-edit" onClick={() => this.editClicked(row)}
                                    color="success"/>}
                        {((this.props.isEntegrator || (showCreditEdit(EntegratorConf.identifier) && (this.props.isDistributor && this.props.currentUser.allowCreditChange))) && this.getTrClass(row) !== 'expired-credit-row') &&
                        <MiniButton title="Sil" faIcon="fa-trash" color="danger"
                                    onClick={() => this.deleteCreditPurchase(row)}/>}
                    </div>
                )
            });
        }
        return (

            <div>
                <Modal isOpen={this.props.isOpen} size='lg'>
                    <ModalHeader toggle={()=>this.props.toggle()}>Kontör İşlemleri</ModalHeader>
                    <ModalBody  style={{paddingTop: '4px'}} >
                        {(this.state.allowWholeCreditLoad || (this.props.isAdmin && !this.props.currentUser.accountant && (this.props.isEntegrator ||
                                    (this.props.isDistributor && this.props.currentUser.allowCreditChange)) && hasUserRight(UserRightsEnum.entegratorSettings.credit.add, this.props.currentUser)) ||
                                (this.props.currentUser.roleId && this.props.currentUser.roleId === 4 && hasUserRight(UserRightsEnum.entegratorSettings.credit.add, this.props.currentUser)))  &&
                        <div style={{paddingLeft: '15px'}} >
                            <SquareButtonX position="leftSide" onClick={this.openLoadCreditModal} img="plus_sign.png"
                                           label="Kontör Yükle"/>
                        </div>
                        }

                        <Row>
                            <Col sm='12' style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                                <div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '0 15px',justifyContent:'center'}}>
                                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: isMobile ? '100%' : '35%', textAlign:'center'}}>
                                        <div style={{width: '15px', height: '15px', background: '#ffd86b', margin: '0 3px'}}></div>
                                        <label style={{margin: 0}}>Kullanım Süresi Bitmek Üzere</label>
                                    </div>

                                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: isMobile ? '100%' : '35%', textAlign:'center'}}>
                                        <div style={{width: '15px', height: '15px', background: '#ff8c8c', margin: '0 3px'}}/>
                                        <label style={{margin: 0}}>Kullanım Süresi Sona Ermiş</label>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <div className="col-sm-12 row" style={{right: '-15px'}}>
                            <Table columns={columns}
                                   content={content}
                                   total={this.state.total}
                                   page={this.state.page}
                                   size={this.state.size}
                                   loading={this.state.loading}
                                   options={["5", "10", "20", "50", "100"]}
                                   fetchData={this.fetch}
                                   manual={this.state.manual}
                                   getTrClass={this.getTrClass}
                            />
                        </div>
                        {(this.state.customerList && this.state.customerList.length>1) &&
                        <div className="col-sm-12 row" style={{right: '-15px', paddingTop: "10px", paddingBottom: "5px"}}>
                            <label style={{margin: 0, fontWeight: "bold"}}>Aynı havuzu kullanan müşteriler</label>
                            <Table columns={columns2}
                                   content={this.state.customerList}
                                   total={this.state.total}
                                   page={this.state.page}
                                   size={this.state.size}
                                   loading={this.state.loading}
                                   options={["5", "10", "20", "50", "100"]}
                                   paginationEnabled={false}
                            />
                        </div>
                        }
                        <Row style={{margin: '0'}}>
                            <Col xs='12' sm='12' md='3' lg='3' xl='3'>
                                Top.Yük.Kontör={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> : this.state.numberOfCredits }
                            </Col>
                            <Col xs='12' sm='12' md='3' lg='3' xl='3'>
                                Aktif.Yük.Kontör={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> : this.state.numberOfActiveCredits }
                            </Col>
                            <Col xs='12' sm='12' md='3' lg='3' xl='3'>
                                Harcanan Kontör={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> : this.state.numberOfCreditsConsumed }
                            </Col>
                            <Col xs='12' sm='12' md='3' lg='3' xl='3'>
                                Kalan Kontör= {this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> :  (this.state.numberOfActiveCredits - this.state.numberOfCreditsConsumed) }
                            </Col>
                        </Row>
                        <Row style={{margin: '0'}}>
                            <Col xs='12' sm='12' md='3' lg='3' xl='3'>
                                Top.Yük.{defterUnitName(EntegratorConf.identifier)}={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> : this.state.areaSize }
                            </Col>
                            <Col xs='12' sm='12' md='3' lg='3' xl='3'>
                                Aktif.Yük.{defterUnitName(EntegratorConf.identifier)}={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> : this.state.activeAreaSize }
                            </Col>
                            <Col xs='12' sm='12' md='3' lg='3' xl='3'>
                                Kullanılan {defterUnitName(EntegratorConf.identifier)}={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> : parseInt(this.state.areaSizeConsumed) }
                            </Col>
                            <Col xs='12' sm='12' md='3' lg='3' xl='3'>
                                Kalan {defterUnitName(EntegratorConf.identifier)}= {this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> : parseInt(this.state.activeAreaSize - this.state.areaSizeConsumed)}
                            </Col>
                        </Row>
                        {[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(EntegratorConf.identifier) && (['interpos', 'bilnex'].includes(VirtualHost.conf.resourcePrefix) || this.props.currentUser.entegrator) &&
                        <Row style={{margin: '0'}}>
                            <Col xs='12' sm='12' md='3' lg='3' xl='3'>
                                Top.Arşiv Kasa Kont. ={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> :  (this.state.numberOfSafe) }
                            </Col>
                            <Col xs='12' sm='12' md='3' lg='3' xl='3'>
                                Aktif Arşiv Kasa Kont. ={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> : (this.state.activeNumberOfSafe) }
                            </Col>
                            <Col xs='12' sm='12' md='3' lg='3' xl='3'>
                                Harcanan A.Kasa Kont. ={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> :  (this.state.numberOfSafeConsumed) }
                            </Col>
                            <Col xs='12' sm='12' md='3' lg='3' xl='3'>
                                Kalan A.Kasa Kont. ={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> : (this.state.activeNumberOfSafe  - this.state.numberOfSafeConsumed) }
                            </Col>
                        </Row>
                        }
                    </ModalBody>
                    <ModalFooter></ModalFooter>
                </Modal>

                {this.state.creditChangeModal &&
                <CreditChangeModal modal={this.state.creditChangeModal}
                                   toggle={this.closeLoadCreditChangeModal}
                                   selectedRow={this.state.selected}
                />
                }
                {this.state.creditModal &&
                <CreditModal modal={this.state.creditModal}
                             toggle={this.closeLoadCreditModal}
                             customer={this.state.customer}
                             priceAmountMap={this.state.priceAmountMap}
                             priceAmountMbMap={this.state.priceAmountMbMap}
                             currentUser={this.props.currentUser}
                />
                }
            </div>
        )
    }
}

export default CreditHistoryModal;